import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionMediaTextComponent } from './section-media-text.component';



@NgModule({
  declarations: [
    SectionMediaTextComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [SectionMediaTextComponent]
})
export class SectionMediaTextModule { }

export interface MediaTextInfo {
  showMaskPC: boolean;
  imageSrc: string;
  title: string;
  description: string;
  showButton: boolean;
  buttonText: string;
  buttonLink: string;
  openInNewTab: boolean;
  showImageSecondary: boolean;
  showRevert: boolean;
}